import { render, staticRenderFns } from "./StatsBasic.vue?vue&type=template&id=5abfec65&scoped=true"
import script from "./StatsBasic.vue?vue&type=script&lang=js"
export * from "./StatsBasic.vue?vue&type=script&lang=js"
import style0 from "./StatsBasic.vue?vue&type=style&index=0&id=5abfec65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abfec65",
  null
  
)

export default component.exports